import { action, observable } from 'mobx'
import { ParentWorkScheduleRequest } from '../requests/parentWorkScheduleRequest'

class ParentWorkScheduleStore {
  @observable workScheduleList = []
  @observable workScheduleDetail = {}

  @action getWorkSchedule = async (
    fromDate,
    toDate,
    companyCode,
    apiUrl
  ) => {
    const response = await ParentWorkScheduleRequest.getWorkSchedule(
      fromDate,
      toDate,
      companyCode,
      apiUrl
    )
    this.workScheduleList = response.data
    return response.data
  }

  @action clearWorkSchedule = () => {
    this.workScheduleList.length = 0
  }

  @action getWorkScheduleDetail = scheduleCode => {
    return new Promise((resolve, reject) => {
      ParentWorkScheduleRequest.getWorkScheduleDetail(scheduleCode)
        .then(response => {
          this.workScheduleDetail = response.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action updateWorkScheduleDetail = detail => {
    this.workScheduleDetail = detail
  }

  @action clearWorkScheduleDetail = () => {
    this.workScheduleDetail = {}
  }
}

export default new ParentWorkScheduleStore()
